/* Keyboard support for the original referral FAQ accordion. */
(() => {
  'use strict';
  if (window.NarwalReferralFAQ) return;
  const states = new Map();

  function setup(root) {
    if (states.has(root)) return;
    const events = new AbortController();
    const items = [...root.querySelectorAll('.accordion')].map((accordion, index) => {
      const title = accordion.querySelector('.accordion-title');
      const answer = accordion.querySelector('.description');
      if (!title || !answer) return null;
      answer.id ||= `${root.id}-answer-${index + 1}`;
      title.setAttribute('role', 'button');
      title.tabIndex = 0;
      title.setAttribute('aria-controls', answer.id);
      title.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        title.click();
      }, { signal: events.signal });
      return { title, answer };
    }).filter(Boolean);

    function sync() {
      items.forEach(({ title, answer }) => {
        // The source domSlider collapses by height, keeping display:block.
        const open = title.classList.contains('active');
        title.setAttribute('aria-expanded', String(open));
        answer.setAttribute('aria-hidden', String(!open));
      });
    }
    const observer = new MutationObserver(sync);
    observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    sync();
    states.set(root, {
      destroy() { events.abort(); observer.disconnect(); states.delete(root); }
    });
  }

  function init(scope) {
    if (scope.matches?.('[data-nwb-referral-faq]')) setup(scope);
    scope.querySelectorAll('[data-nwb-referral-faq]').forEach(setup);
  }
  window.NarwalReferralFAQ = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, state] of states) if (event.target.contains(root)) state.destroy();
  });
})();
